module.exports = __webpack_public_path__ + "media/images/amenities_icons/projector-14a4d9b4b1453bdbb7d8401744a9aa65.svg";